import { asMenuItem, MenuItem } from "../../components/menu";

const ICON = { ios: "f7:device_phone_portrait", md: "material:devices" };

const TransferButton = asMenuItem(({ onClick }) => (
  <MenuItem
    className="transfer-device"
    title="Auf anderem Gerät öffnen"
    icon={ICON}
    tone="blue"
    onClick={onClick}
  />
));

export default TransferButton;
